/**
 * Created by anatolij on 06.10.2026
 */

const RoyalLeagueStagesWindow = Prefab.createWindow(
    "royal_league_stages_window",
    "royal_league_stages_window_prefab_json"
);
